var taskTable;

function InitTaskDataTable(dateFormat) {

  /*  $(document).ready(function () {*/
        console.log("creating new table1");

        if (taskTable != null) {
            try {
                taskTable.destroy();
                taskTable = null;
            } catch (e) {

            }
        }

        taskTable = $('#taskViewList').DataTable({
            "order": [[2, "desc"]],
            pageLength: 25,
            autoWidth: false,
            "columnDefs": [
                { "width": "48px", "targets": 0 }, //Task #
                { "width": "64px", "targets": 1 }, //State
                { "width": "160px", "targets": 2 }, //Created
                { "width": "96px", "targets": 3 }, //Due date
                { "width": "48px", "targets": 4 }, //Priority
                { "width": "196px", "targets": 5 }, //Title
                { "width": "148px", "targets": 6 }, //Assigned to
                { "width": "128px", "targets": 7 }, //Unit
            ],
            "language": {
                "emptyTable": "There are currently no tasks. Create a new task with the button in the top right",
                "info": "Showing _START_ to _END_ of _TOTAL_ tasks",
                "infoEmpty": "Showing 0 to 0 of 0 tasks",
                "infoFiltered": "(filtered from _MAX_ total tasks)",
                "lengthMenu": "Show _MENU_ tasks"
            },
            columns: [
                {
                    data: 'taskNumber',

                },
                {
                    data: 'state',
                    render: function (data, type) {
                        if (type === 'display') {
                            var circleColor = '';
                            var stateText = '';
                            switch (data) {
                                case 3:
                                    circleColor = '#B2B2B2';
                                    stateText = "To Do";
                                    break;
                                case 4:
                                    circleColor = '#007ACC';
                                    stateText = "Doing";
                                    break;
                                case 5:
                                    circleColor = '#339933';
                                    stateText = "Done";
                                    break;
                            }
                            return ' <i class="fas fa-circle" style="color:' + circleColor + ' ;" ></i><span style="margin-left:5px;">' + stateText +'</span>'
                            //return '<span class="flag ' + country + '"></span> ' + data;
                        }

                        return data;
                    }
                },
                {
                    data: 'created',
                    render: function (data, type) {
                        if (type === 'display') {
                            if (dateFormat == 0) {
                                return timestampToJexcelDate(data);}
                            else {
                                return timestampToUsDate(data);
                            }
                            
                           
                        }

                        return data;
                    }
                },
                {
                    data: 'duedate',
                    render: function (data, type) {
                        if (type === 'display') {

                            try {
                                var resultDate = '';
                                var dd = data.getDate();
                                var yy = data.getFullYear();
                                var parsedDate = moment(data);
                                if (data != null) {
                                    if (dateFormat == 0) {

                                        resultDate = dd + " " + parsedDate.format('MMMM') + ", " + yy
                                    } else {
                                        resultDate = parsedDate.format('MMMM') + " " + dd + ", " + yy;
                                    }
                                }
                            } catch (e) {
                                resultDate = '';
                            }
                            return resultDate;
                          
                        }

                        return data;
                    }
                    //render: function (data, type, row, meta) {
                    //    return type === 'display' ?
                    //        '<progress value="' + data + '" max="9999"></progress>' :
                    //        data;
                    //}
                },
                {
                    data: 'priority',
                    render: function (data, type) {
                        if (type === 'display') {

                            if (data == 3) {
                                return '<strong><span style="color:red;">Critical</span></strong>';
                            } else if (data == 2){
                                return '<span>High</span>';
                            }
                            else if (data == 1) {
                                return '<span>Medium</span>';
                            }
                            else if (data == 0) {
                                return '<span>Low</span>';
                            }

                            return "";
                        }

                        return data;
                    }
                },
                {
                    data: "title"
                },
                {
                    data: "assignedTo"
                },
                {
                    data: "unit"
                },
                {
                    data: "text"
                },

            ]
        });

        $('#taskViewList tbody').on('click', 'tr', function () {
            var data = taskTable.row(this).data();
            console.log(data);

            var taskNumberParsed = -1;

            try {
                taskNumberParsed = parseInt(data.taskNumber);
            } catch (e) {

            }

            if (taskNumberParsed > 0) {
                DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnTaskClickedFromGrid', taskNumberParsed);
            }

       
            
        });

        $("#taskViewList tr").css('cursor', 'pointer');

    //});

    return 1;
}

function FilterTaskDataTableOnAssignedTo(assignedToName) {
    if (taskTable != null) {
        taskTable.columns(6).search(assignedToName).draw();
    }
    
}

function RemoveAssignedToFilterTaskDataTable(arg) {
    if (taskTable != null) {
        taskTable.columns(6).search('').draw();
    }
    
}

function PopulateToTaskDataTable(rows) {

    console.log("rows");
    console.log(rows);

    var tasks = [];

    rows.forEach(row => tasks.push({
        taskNumber: row.taskId,
        state: row.taskState,
        created: new Date(row.taskCreated),
        duedate: row.taskDueDate == null ? null : new Date(row.taskDueDate),
        priority: row.taskPriority,
        title: row.taskTitle,
        assignedTo: row.taskAssignedTo,
        unit: row.taskReceiverUnit,
        text: row.taskText
    }));

  //  tasks = tasks.reverse();

    console.log("tasks");
    console.log(tasks);

    try {
        taskTable.rows().remove()
    } catch (e) {
        console.log(e);
    }


    try {
        taskTable.rows.add(tasks);
        taskTable.draw();

    } catch (e) {
        console.log(e);
    }

  

    console.log("updated");
}

function ReloadTaskDataTable(row) {

    console.log("reloading table..");
    if (taskTable != null) {
        console.log("destroying table..");
        taskTable.destroy();
        setTimeout(function () {
            console.log("buuilding table..");
            InitTaskDataTable();
        }, 2000);
    }

    //  taskTable.row.add([row.taskEventTaskId, row.taskEventState, 'Edinburgh']);

    //$(document).ready(function () {
    //    //$('#example').DataTable().destroy();
    //    console.log("creating new table2");
    //   // $('#example').DataTable();

    //    //taskTable.clear();
    //    var data = taskTable.data();
    //    taskTable.draw();
    //});
}


function ForceStateSelectIndex(valueToSelect) {
    var element = document.getElementById("taskDetailViewStateSelect");
    element.value = valueToSelect;
}

function ForcePrioritySelectIndex(valueToSelect) {
    var element = document.getElementById("taskDetailViewPrioritySelect");
    element.value = valueToSelect;
}


function InitTaskViewGuardsTypeahead(guards) {

    var guardsRaw = [];

    var count = guards.length;
    for (var i = 0; i < count; i++) {
        var name = guards[i].guardName;
        if (name !== "") {
            guardsRaw.push(name);
        }
    }

    console.log(guardsRaw);

    $(document).ready(function () {
        buildTypeahead('#guardTaskViewSelect .typeahead', "guards", guardsRaw);
    });

    

    return true;
}

function InitTaskViewResidentsTypeahead(peopleString) {

    const peopleConst = BINDING.conv_string(peopleString);
    var people = JSON.parse(peopleConst);

    var peopleRaw = [];

    var count = people.length;
    for (var i = 0; i < count; i++) {
        var name = people[i].receiverName;
        var unit = people[i].receiverUnit;
        var phone = people[i].receiverPhonenumber;
        var email = people[i].receiverEmail;
        if (name !== "") {
            peopleRaw.push(unit + ", " + name);
        }
    }

    buildTypeahead('#residentTaskViewSelect .typeahead', "people", peopleRaw);

    return true;
}


//////

var taskDueDateRangePickerElementId = 'taskDueDateRangePickerViewer';
var taskDueDateRangePickerStartSelected = '';

var lastTaskViewDateRangeValueShown = null;

function buildTaskDueDateRangePickers(dateFormat, startDate) {

    $(document).ready(function () {

        $('#' + taskDueDateRangePickerElementId).on('apply.daterangepicker', function (ev, picker) {
            console.log("clicked apply setting date");
            // alert("New date range selected: '" + picker.startDate.format('YYYY-MM-DD') + "' to '" + picker.endDate.format('YYYY-MM-DD') + "'");

            //console.log(start);
            //console.log(start.date());
            //console.log(start.month());
            //console.log(start.year());
           // taskDueDateRangePickerStartSelected = start.toISOString();
            var start = picker.startDate;
            taskDueDateRangePickerStartSelected = start.toISOString();

            console.log(dateFormat);
            //dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
            var resultDate = '';

            if (dateFormat == 0) {
                resultDate = n2(start.date()) + "/" + n2(start.month() + 1) + "/" + start.year();
            } else {
                resultDate = n2(start.month() + 1) + "/" + n2(start.date()) + "/" + start.year();
            }

            document.getElementById('taskDueDateRangePickerViewer').value = resultDate;

            console.log(taskDueDateRangePickerStartSelected);

        });

        $('#' + taskDueDateRangePickerElementId).on('cancel.daterangepicker', function (ev, picker) {
            console.log("clicked cancel setting date");
            // alert("New date range selected: '" + picker.startDate.format('YYYY-MM-DD') + "' to '" + picker.endDate.format('YYYY-MM-DD') + "'");
            document.getElementById('taskDueDateRangePickerViewer').value = '';
       

        });

       

        $('#' + taskDueDateRangePickerElementId).on('show.daterangepicker', function (ev, picker) {

            console.log(picker.container[0]);

            $(picker.container[0]).find('.drp-buttons .cancelBtn').text("No due date");
            //console.log(elx);

            //$($(picker.container[0]).find('.drp-buttons .cancelBtn')).each(function (i, obj) {
            //    console.log(obj);
             
            //});

            var currentValue = document.getElementById('taskDueDateRangePickerViewer').value;
            lastTaskViewDateRangeValueShown = currentValue;
        });

        $('#' + taskDueDateRangePickerElementId).on('hide.daterangepicker', function (ev, picker) {
            //$('#book_date').val('');
            //console.log("clicked outside setting date to empty");
            //document.getElementById('taskDueDateRangePickerViewer').value = '';

            if (lastTaskViewDateRangeValueShown != null) {
                document.getElementById('taskDueDateRangePickerViewer').value = lastTaskViewDateRangeValueShown;
                lastTaskViewDateRangeValueShown = null;
            }

        });


    });

    $(document).ready(function () {
        $('#' + taskDueDateRangePickerElementId).daterangepicker({
            singleDatePicker: true,
            timePicker: false,
            startDate: moment().add(0, 'day')
        }, function (start, end, label) {

            //console.log(start);
            //console.log(start.date());
            //console.log(start.month());
            //console.log(start.year());
            //taskDueDateRangePickerStartSelected = start.toISOString();

            //console.log(dateFormat);
            ////dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
            //var resultDate = '';

            //if (dateFormat == 0) {
            //    resultDate = n2(start.date()) + "/" + n2(start.month() + 1) + "/" + start.year();
            //} else {
            //    resultDate = n2(start.month() + 1) + "/" + n2(start.date()) + "/" + start.year();
            //}

            //document.getElementById('taskDueDateRangePickerViewer').value = resultDate;
         
            //console.log(taskDueDateRangePickerStartSelected);

        });

    });
}

function setTaskDueDateRangerPickerDate(date) {
    try {
        var dateToSet = new Date(date);
        $('#' + taskDueDateRangePickerElementId).data('daterangepicker').setStartDate(dateToSet);
        $('#' + taskDueDateRangePickerElementId).data('daterangepicker').setEndDate(dateToSet);
    } catch (e) {
        console.log(e);
    }
}


function getTaskDueDateRangePickerStartSelected() {
    return taskDueDateRangePickerStartSelected;
}

//////

function maintenanceTaskDone(maintenanceTaskId, el) {

    //var buttonElementId = "maintenanceTaskDoneButton-" + maintenanceTaskId;

    //console.log("buttonElementId: " + buttonElementId);

    var buttonElement = el;

    console.log("buttonElement to set animation");
    console.log(buttonElement);


    $(buttonElement).addClass("slide_right_done");
    //buttonElement.classList.add('slide_right_done');

   // buttonElement.innerHTML = "DONE";



    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnMaintenanceTaskClickedDoneFromGrid', maintenanceTaskId);

    setTimeout(function () {

       
       

        console.log("click event btn");
        console.log(buttonElement);

      //  $(".button_slide").removeClass("slide_right_done");


    }, 1000);


   
}

function removeAllDoneButtonAnimations(arg) {
    $(".button_slide").removeClass("slide_right_done");
}

//function (el, overdue, ooingng) {

//    setTimeout(function () {
//        tippy('#' + el, {
//            arrow: false,
//            content: '<span>' + 'A VisitForm Ultimate license is required to send texts.' + '</span>',
//            allowHTML: true
//        });
//    }, 3500);

//}

function createMaintenanceTaskStatusTooltip(el, overdue, ongoing, endsSoon) {

    var text = "Done and on schedule";

    if (overdue) {
        text = "Overdue and to be done as soon as possible";
    }
    else if (ongoing) {
        if (endsSoon) {
            text = "Due in less than one hour";
        }
        else {
            text = "Planned time passed and should be done before due date";
        }
        
    }

    setTimeout(function () {
        tippy('#' + el, {
            content: '<span>' + text + '</span>',
            allowHTML: true
        });
    }, 1500);

}


function createMaintenanceTaskTooltip(el, text) {


    setTimeout(function () {
        tippy(el, {
            content: '<span>' + text + '</span>',
            allowHTML: true
        });
    }, 1500);

}

function showMaintenanceTaskModalInfo(maintenanceTask) {

    console.log("maintenanceTask");
    console.log(maintenanceTask);

    document.getElementById('showMaintenanceTaskModalTitle').innerHTML = maintenanceTask.maintenanceTaskTitle;

    //

    if (maintenanceTask.maintenanceTaskIntervalDescription) {
        document.getElementById('showMaintenanceTaskModalIntervalDescription').innerHTML = maintenanceTask.maintenanceTaskIntervalDescription;
        $('#showMaintenanceTaskModalIntervalDescriptionLabel').show();
    }
    else {
        document.getElementById('showMaintenanceTaskModalIntervalDescription').innerHTML = "";
        $('#showMaintenanceTaskModalIntervalDescriptionLabel').hide();
    }

    //

    if (maintenanceTask.maintenanceTaskDescriptionHelpInfo) {

        var helpInfoMessageText = maintenanceTask.maintenanceTaskDescriptionHelpInfo;

        try {
            helpInfoMessageText = helpInfoMessageText.replace(/\n/g, '<br>');
        }
        catch {

        }


        document.getElementById('showMaintenanceTaskModalDescriptionHelpInfo').innerHTML = helpInfoMessageText;
        $('#showMaintenanceTaskModalDescriptionHelpInfoLabel').show();
    }
    else {
        document.getElementById('showMaintenanceTaskModalDescriptionHelpInfo').innerHTML = "";
        $('#showMaintenanceTaskModalDescriptionHelpInfoLabel').hide();
    }


    //

    if (maintenanceTask.maintenanceTaskDescription) {
        document.getElementById('showMaintenanceTaskModalDescription').innerHTML = maintenanceTask.maintenanceTaskDescription;
        $('#showMaintenanceTaskModalDescriptionLabel').show();
    }
    else {
        document.getElementById('showMaintenanceTaskModalDescription').innerHTML = "";
        $('#showMaintenanceTaskModalDescriptionLabel').hide();
    }

    //
   
    $('#showMaintenanceTaskInfoModal').modal();

}